import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '@store';
import { IconEdit, ClickOutsideDetector, PermissionEnum } from '@ui/src';
import { onTemplateChange } from '../../hoc/notification-settings/store/slices';
import { TemplateRowTypes } from './types';

import cn from './notification-settings.module.css';

const TemplateRow = ({
  template,
  isSelectedRow,
  setRenamePopupVisible,
}: TemplateRowTypes) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  const dispatch = useAppDispatch();

  return (
    <div
      className={`${cn.columnRow} ${isSelectedRow ? cn.columnRowActive : ''} ${
        !template?.active ? cn.inactive : ''
      }`}
    >
      <button
        onClick={() => {
          dispatch(onTemplateChange(template?.id as string));
        }}
        className={`${cn.columnRowLink} ${
          isSelectedRow ? cn.columnRowLinkActive : ''
        }`}
        aria-label="select row"
        type="button"
      />
      <div className={cn.columnRowWrapper}>
        <div className={cn.columnRowTitle}>{template?.name}</div>
        {!template?.active && <div className={cn.inactiveText}>Inactive</div>}
      </div>
      {activePermissions?.includes(
        PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_EDIT_ACTION,
      ) && (
        <div className={cn.menuButtonWrapper}>
          <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
            <>
              <button
                type="button"
                className={cn.menuButton}
                aria-label="Menu button"
                onClick={() => setMenuVisible(true)}
              >
                <span />
              </button>
              {menuVisible && (
                <div className={cn.menu}>
                  <button
                    type="button"
                    className={cn.menuItem}
                    onClick={() => {
                      setRenamePopupVisible(true);
                      setMenuVisible(false);
                    }}
                  >
                    <IconEdit />
                    Edit
                  </button>
                </div>
              )}
            </>
          </ClickOutsideDetector>
        </div>
      )}
    </div>
  );
};

export default TemplateRow;
